import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Radio } from "antd";
import Collapse, { Panel } from "../../../../common/component/Collapse";
import {
  FormWrapperInputComponent,
  HeaderComponent
} from "../../../../common/component/Index";
import Wrapper from "../../../../common/component/Wrapper";
import {
  DETAIL_ACTIONS,
  CAMPAIGN as CAMPAIGN_ENUM
} from "../../../../../../constants/Define";
import {
  capitalizeFirstLetter,
  checkUndefine
} from "../../../../../../helpers/functions";
import { useTranslation } from "react-i18next";
import { toArray } from "lodash";
import ListSKU from "../ListSKU";
import ListFnbProduct from "../ListFnbProduct";
import Input from "../../../../common/component/Input";

const defaultCollapseKey = "campaignUseProduct";

function UseProductsSection(props) {
  const {
    campaign,
    validation,
    action,
    tagGroupDetailState,
    supplierState,
    onChange,
    setCampaign,
    renderInfoTooltip,
    getAllSku,
    getSupplierAll,
    onChangeMaxMin
  } = props;

  const { t } = useTranslation();
  const [collapseKey, setCollapseKey] = useState();
  const isFnbCampaign = (campaign.productType || []).includes(CAMPAIGN_ENUM.PRODUCT_TYPE.FNB.value);
  const selectedFnbMenuItems = campaign.menuItemIds || [];

  const onChangeFnbProducts = ({ outletIds, menuIds, menuItemIds }) => {
    setCampaign({
      ...campaign,
      outletIds,
      menuIds,
      menuItemIds,
    });
  };

  const onToggleCollapse = () => {
    if (collapseKey) {
      setCollapseKey();
    } else {
      setCollapseKey(defaultCollapseKey);
    }
  };

  useEffect(() => {
    const hasError = validation && (validation.minItemCount || validation.maxItemCount || validation.minOrderAmount)
    if (hasError && !collapseKey) {
      setCollapseKey(defaultCollapseKey);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [validation])

  return (
    <Collapse
      activeKey={collapseKey}
      bordered={false}
      defaultActiveKey={defaultCollapseKey}
      style={{ width: "100%", background: "inherit" }}
      expandIconPosition={"right"}
      onChange={onToggleCollapse}
    >
      <Panel
        key={defaultCollapseKey}
        header={
          <HeaderComponent
            title={t("item.campaign.skuIds")}
            className="col-md-12"
            style={{
              userSelect: "none",
              paddingTop: "unset",
              paddingBottom: "unset"
            }}
          />
        }
      >
        <Wrapper className={"row campaign-collapse-row"}>
          <Wrapper className="col-md-6">
            <FormWrapperInputComponent
              labelTitle={capitalizeFirstLetter(
                (
                  t("action.select") +
                  " " +
                  t("item.campaign.skuIds")
                ).toLowerCase()
              )}
              visible={action !== DETAIL_ACTIONS.TRANSLATE}
            >
              <Wrapper>
                <Radio.Group
                  value={campaign.optionSku}
                  onChange={e => onChange("optionSku", e.target.value)}
                >
                  {toArray(CAMPAIGN_ENUM.OPTION_SKU).map(item =>
                    renderInfoTooltip(
                      t(`item.campaign.optionSku.description.${item.key}`),
                      <Radio key={item.key} value={item.id} className="mr-0">
                        {t(`item.campaign.optionSku.${item.key}`)}
                      </Radio>,
                      "mr-3"
                    )
                  )}
                </Radio.Group>
                {campaign.optionSku === CAMPAIGN_ENUM.OPTION_SKU.SPECIFIC.id &&
                  campaign.productType &&
                  campaign.productType.length > 0 &&
                  !isFnbCampaign && (
                    <ListSKU
                      buttonText={capitalizeFirstLetter(
                        (
                          t("action.select") +
                          (campaign.skuIds.length
                            ? ` ${campaign.skuIds.length} `
                            : " ") +
                          t("item.campaign.skuIds")
                        ).toLowerCase()
                      )}
                      tagGroupDetailState={tagGroupDetailState}
                      supplierState={supplierState}
                      getAllSku={getAllSku}
                      getSupplierAll={getSupplierAll}
                      productTypes={campaign.productType}
                      skuIds={campaign.skuIds}
                      onChange={listSKU => onChange("skuIds", listSKU)}
                    />
                  )}
                {isFnbCampaign && (
                    <ListFnbProduct
                      buttonText={capitalizeFirstLetter(
                        (
                          t("action.select") +
                          (selectedFnbMenuItems.length
                            ? ` ${selectedFnbMenuItems.length} `
                            : " ") +
                          t("item.campaign.skuIds")
                        ).toLowerCase()
                      )}
                      propertyIds={campaign.propertyIds}
                      outletIds={campaign.outletIds}
                      menuIds={campaign.menuIds}
                      menuItemIds={selectedFnbMenuItems}
                      onChange={onChangeFnbProducts}
                    />
                  )}
              </Wrapper>
            </FormWrapperInputComponent>
          </Wrapper>
          <Wrapper className="col-md-6">
            <FormWrapperInputComponent
              dataValidation={campaign.minItemCount}
              validation={validation.minItemCount}
              messageBelowInput={true}
              className="with-fix"
              labelTitle={t(
                `item.campaign.${
                  isFnbCampaign ? "minFnbItemCount" : "minItemCount"
                }`
              )}
              visible={action !== DETAIL_ACTIONS.TRANSLATE}
            >
              <Input
                type="currency"
                autoComplete="off"
                prefix={renderInfoTooltip(
                  t(`item.campaign.minItemCountNull`, { min: 1 })
                )}
                className="form-control"
                name="minItemCount"
                onChange={e =>
                  onChangeMaxMin(
                    "minItemCount",
                    Number(e.target.value),
                    "maxItemCount"
                  )
                }
                value={checkUndefine(campaign.minItemCount)}
              />
            </FormWrapperInputComponent>
          </Wrapper>
          <Wrapper className="col-md-6">
            <FormWrapperInputComponent
              dataValidation={campaign.maxItemCount}
              validation={validation.maxItemCount}
              className="with-fix"
              labelTitle={t(
                `item.campaign.${
                  isFnbCampaign ? "maxFnbItemCount" : "maxItemCount"
                }`
              )}
              visible={action !== DETAIL_ACTIONS.TRANSLATE}
            >
              <Input
                type="currency"
                autoComplete="off"
                prefix={renderInfoTooltip(t(`item.campaign.maxItemCountNull`))}
                className="form-control"
                name="maxItemCount"
                onChange={e =>
                  onChangeMaxMin(
                    "maxItemCount",
                    Number(e.target.value),
                    "minItemCount",
                    false
                  )
                }
                value={checkUndefine(campaign.maxItemCount)}
              />
            </FormWrapperInputComponent>
          </Wrapper>
          <Wrapper className="col-md-6">
            <FormWrapperInputComponent
              dataValidation={campaign.minOrderAmount}
              validation={validation.minOrderAmount}
              className="with-fix with-currency-suffix"
              labelTitle={t(`item.campaign.totalOrderAmount`)}
              visible={action !== DETAIL_ACTIONS.TRANSLATE}
            >
              <Input
                type={`currency`}
                autoComplete="off"
                suffix={t(`currency`)}
                prefix={renderInfoTooltip(
                  t(`item.campaign.totalOrderAmountNull`, {
                    min: 0,
                    currency: t(`currency`)
                  })
                )}
                placeholder={capitalizeFirstLetter(
                  (
                    t("placeHolderForm.input") +
                    " " +
                    t("item.campaign.totalOrderAmount")
                  ).toLowerCase()
                )}
                className="form-control"
                name="minOrderAmount"
                onChange={e =>
                  onChange("minOrderAmount", Number(e.target.value))
                }
                value={checkUndefine(campaign.minOrderAmount)}
                disabled={false}
              />
            </FormWrapperInputComponent>
          </Wrapper>
        </Wrapper>
      </Panel>
    </Collapse>
  );
}

UseProductsSection.propTypes = {
  campaign: PropTypes.object,
  validation: PropTypes.object,
  action: PropTypes.string,
  tagGroupDetailState: PropTypes.object,
  supplierState: PropTypes.object,
  onChange: PropTypes.func,
  setCampaign: PropTypes.func,
  onChangeMaxMin: PropTypes.func,
  getAllSku: PropTypes.func,
  getSupplierAll: PropTypes.func,
  renderInfoTooltip: PropTypes.func
};

UseProductsSection.defaultProps = {
  campaign: {},
  validation: {},
  action: "",
  tagGroupDetailState: {},
  supplierState: {},
  onChange: () => {},
  setCampaign: () => {},
  onChangeMaxMin: () => {},
  getAllSku: () => {},
  getSupplierAll: () => {},
  renderInfoTooltip: () => {}
};

export default UseProductsSection;
